import { defineAsyncComponent, createApp, Component, App } from "vue";

type AsyncComponent<T extends Component> = () => Promise<{ default: T }>;

export function useAsyncComponent<T extends Component>(asyncImport: AsyncComponent<T>, props?: Record<string, any>) {
    let app: App<Element>;
    let appWrapper: Element;

    const showDynamicComponent = () => {
        if (app) {
            return;
        }

        const dynamicComponent = defineAsyncComponent(asyncImport);
        app = createApp(dynamicComponent, props);

        if (!appWrapper) {
            appWrapper = document.createElement("div");
            document.body.appendChild(appWrapper);
        }

        app.mount(appWrapper);
    };

    const hideDynamicComponent = () => {
        if (app) {
            app.unmount();
            app = null;

            if (appWrapper) {
                document.body.removeChild(appWrapper);
                appWrapper = null;
            }
        }
    };

    return {
        showDynamicComponent,
        hideDynamicComponent,
    };
}
